import fetch from '../utils/fetch';
import { rosterUrl } from 'endpoints';
import RosterSDK from '@nackle/roster-sdk';

export default new RosterSDK( rosterUrl, fetch, undefined );
